import React, { memo, useCallback, useEffect } from 'react';

import { useDrop } from 'react-dnd';
import Circle from '../../../components/GoogleMaps/Circle';
import CustomMap from '../../../components/GoogleMaps/CustomMap';
import Marker from '../../../components/GoogleMaps/Marker';

import { useMaps } from '../../../hooks/maps';

import { Container } from './styles';

interface IProps {
  setPosX: React.Dispatch<React.SetStateAction<number>>;
  setPosY: React.Dispatch<React.SetStateAction<number>>;
  data: {
    geoHashs: { geoHash: string; length: number }[];
    excludedGeoHashes?: { geoHash: string; length: number }[];
  };
  preview?: boolean;
  center?: google.maps.LatLngLiteral;
}

interface DragItem {
  posX: number;
  posY: number;
}

const Map = ({
  setPosX,
  setPosY,
  data,
  preview = false,
  center: propCenter,
}: IProps) => {
  const {
    pin,
    setPin,
    center,
    radius,
    setCenter,
    getCurrentPosition,
    setPlaceSelected,
    getFirstStreetAddressByLocation,
  } = useMaps();

  // const [zoom, setZoom] = useState<number>(5);

  const [, drop] = useDrop(
    () => ({
      accept: 'box',
      drop(item: DragItem, monitor) {
        const clientX = monitor.getClientOffset()?.x as number;
        const clientY = monitor.getClientOffset()?.y as number;
        setPosX(clientX - 159);
        setPosY(clientY - 90);
        return undefined;
      },
    }),
    [],
  );

  const onClick = useCallback(
    async ({ latLng }: google.maps.MapMouseEvent) => {
      if (latLng) {
        setPin(latLng);
        try {
          setPlaceSelected(await getFirstStreetAddressByLocation(latLng));
        } catch {
          // it's not necessary
        }
      }
    },
    [getFirstStreetAddressByLocation, setPin, setPlaceSelected],
  );

  useEffect(() => {
    if (preview && propCenter) {
      setCenter(propCenter);
    } else if (preview) {
      setCenter({ lat: -13.14, lng: -58.4 });
    } else getCurrentPosition(setCenter);
  }, [getCurrentPosition, preview, setCenter, propCenter]);

  const heatMapData = {
    geoHashs: data?.geoHashs || [{ geoHash: '', length: 0 }],
    excludedGeoHashs: data?.excludedGeoHashes,
  };

  return (
    <Container ref={drop}>
      <CustomMap
        center={center}
        onClick={onClick}
        heatMapGeoHashes={heatMapData}
        zoom={preview ? 5 : 14}
        minZoom={3}
        isFractionalZoomEnabled
      >
        {pin && <Marker position={pin} />}
        {pin && <Circle center={pin} radius={radius} />}
      </CustomMap>
    </Container>
  );
};

export default memo(Map);
